(function($){
  function debounce(func, wait) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }
  
  $('.close-bar').on('click', function() {
    $(this).parents('.announcement_bar').slideUp(300);
  });

  $('.icon-cart').on('click', function() {
    $('.side_cart').addClass('active');
    $('body').addClass('over-hid');
  });

  $('.side-cart-close').on('click', function() {
    $('.side_cart').removeClass('active');
    $('body').removeClass('over-hid');
  });

  $('.pageoverlay').on('click', function() {
    $('.side_cart').removeClass('active');
    $('body').removeClass('over-hid');
  });

  $('.m-filter').on('click', function() {
    $('.choose_category').toggleClass('active', 500);
    $(this).toggleClass('active', 500)
  });

  $('.acc-setting a').on('click', function() {
    $('.account-list').toggle(500);
  });

  $('.header__nav-button').on('click', function() {
    $(this).toggleClass('active', 500);
    $('#mobile-menu').toggleClass('open', 500)
  })

  $('.btn-next').on('click', function() {
    $(this).next('.MegaMenu').addClass('active-slide', 500)
  })

  $('.back-btn').on('click', function() {
    $('.MegaMenu').removeClass('active-slide', 500)
  })

  $(document).on('ready', function(){
    $('#charcount').on('keyup', function () {
      var max = 200;
      var len = $(this).val().length;
      if (len >= max) {
        $('#charNum').text(' you have reached the limit');
      } else {
        var char = max - len;
        $('#charNum').text(char + ' Character Remaining');
      }
    });
  });
    

  $('.close-join').on('click', function() {
    $('.join_wrap').removeClass('active'); 
  });

  $('.user-icon').on('click',  function() {
    $(this).next('ul').toggleClass('active');
  });
    
  $(document).on('ready', function (){
    $("#accordion .ingre.collapsed").on('click', function (){
      $('html, body').animate({
        scrollTop: $("#accordion").offset().top - 200
      }, 2000);
    });
  });

  $('.s-down').on('click', function(e) {
    e.preventDefault(); // prevent hard jump, the default behavior
    var target = $(this).attr("href"); // Set the target as variable

    $('html, body').stop().animate({
      scrollTop: $(target).offset().top - 50
    }, 600, function() {
      console.log($(target).offset().top);
    });

    return false;				
  });	

  function scaleToFill() {
    $('video.video-background').each(function(index, videoTag) {
      var $video = $(videoTag),
          videoRatio = videoTag.videoWidth / videoTag.videoHeight,
          tagRatio = $video.width() / $video.height(),
          val;
      
      if (videoRatio < tagRatio) {
        val = tagRatio / videoRatio * 1.02; // size increased by 2% because value is not fine enough and sometimes leaves a couple of white pixels at the edges
      } else if (tagRatio < videoRatio) {
        val = videoRatio / tagRatio * 1.02;
      }
        
      $video.css('transform','scale(' + val  + ',' + val + ')');
      $('video.video-background').show();
    });    
  }

  $(function () {
    scaleToFill();
    $('.video-background').on('loadeddata', scaleToFill);
    
    $(window).on('resize', function() {
      scaleToFill();
    });
  });

  $('#subs').on('click', function(){
    $('.purchase_text').hide();
    $('.sub_text').show();
  });

  $('#purch').on('click', function(){
    $('.purchase_text').show();
    $('.sub_text').hide();
  });

    
  $('body').on("click", ".back-sub", function(){
    $('#subs').trigger( "click" );
    $('.purchase_text').hide();
    $.parrents('.sub_text').show();
  });
    
  $(".u-qty .QuantitySelector__Button").on("click", function() {
    var $button = $(this);
    var oldValue = $button.parent('.u-qty').find("input").val();

    if ($button.hasClass('u-plus')) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 1) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
      }
    }
    $button.parent().find("input").val(newVal);
  });

  var memberBox = $('.member_box');
  if (memberBox.length) {
    var pos = $('.member_box').offset().top+300; 
    pos = pos+300;

    $(window).on('scroll', function(){
      if($('html').scrollTop()>pos) {
        $('.sticky-btn').addClass('fixed');
      }
      else {
        $('.sticky-btn').removeClass('fixed');
      }
    });
  }

  $('.logo-slider-toggle').on('click', function() {
    if ($(this).hasClass('logo-play')){
      $(this).parents('.row').find('.slick-logo-wrapper').slick('slickPause');
      $(this).html('<svg aria-label="play" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16"><path fill="#000000" d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM6 4.5l6 3.5-6 3.5z"></path></svg>') 
      $(this).attr({ "aria-pressed": 'true', "aria-label": 'play'});
    } else {
      $(this).parents('.row').find('.slick-logo-wrapper').slick('slickPlay');
      $(this).html('<svg aria-label="edge" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16"><path fill="#000000" d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h2v6h-2zM9 5h2v6h-2z"></path></svg>') 
      $(this).attr( { "aria-pressed": 'false', "aria-label": 'pause'});
    }
    
    $(this).toggleClass('logo-play');
  });

  $(window).on('resize', function(){
    containerWidth();
  }); 

  $(document).on("scroll", function(){
    if($(document).scrollTop() > 70 ){
      $("body:not(#sizzle) #header").addClass("shrink");
    }
    else
    {
      $("body:not(#sizzle) #header").removeClass("shrink");
    }
  });

  $(window).on('load', function() {
    var now, lastDatePopupShowed;
    now = new Date();

    if (localStorage.getItem('lastDatePopupShowed') !== null) {
      lastDatePopupShowed = new Date(parseInt(localStorage.getItem('lastDatePopupShowed')));
    }

    if (((now - lastDatePopupShowed) >= (15 * 86400000)) || !lastDatePopupShowed) {
      var delay = $('#agepopup').attr("data-delay");
      localStorage.setItem('lastDatePopupShowed', now);
    }
  });

  $('.doze_slide').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
    responsive:{ 
      0:{
          items:1,
          margin:0
      },
      640:{
          items:2,
          margin:15
      },
      992:{
          items:2
      },
      1200:{
          items:3
      }
    }
  });

  // SLices
  $('.red-titles').slick({
    autoplay: true,
    autoplaySpeed: 0,
    dots: false,
    infinite: true,
    speed: 8000,
    slide: 'div',
    arrows:false,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: 'linear',
    responsive: [
      {
      breakpoint: 720,
      settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1
      }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.juice-slides').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
      breakpoint: 720,
      settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1
      }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  function crewSliderSetup() {
    if ($('.crew-slider_row').hasClass('slick-initialized')) {
        $('.crew-slider_row').off();
        $('.crew-slider_row').slick('unslick');
    }

    $('.crew-slider_row').on('init', function(event, slick){
        adjustSlideHeights('.crew-slider_row');
        
        var allSlides = $('.crew-slider_row .slick-slide');
        var allActiveSlides = allSlides.filter('.slick-active');
        allSlides.css('opacity', '0');
        allSlides.css('pointer-events', 'none');
        allActiveSlides.css('opacity', '1');
        allActiveSlides.css('pointer-events', 'inherit');

        const triggers = document.querySelectorAll('.read-more.modal-trigger');
        const closeModalButtons = document.querySelectorAll('.close-modal');
      
        triggers.forEach(trigger => {
          trigger.addEventListener('click', function () {
            const modalId = this.getAttribute('data-id');
            const modalText = this.getAttribute('data-text');
            const modal = $(`#crew-modal`);
            modal.find('[data-modal-text]').text(modalText);
            modal.css('display', 'block');
          });
        });
      
        closeModalButtons.forEach(button => {
          button.addEventListener('click', function () {
            const modal = this.closest('.fixed');
            modal.show();
          });
        });
    });

    $('.crew-slider_row').slick({
        infinite: true,
        slidesToShow: 3,
        arrows: true,
        prevArrow: $('.prev-btn'),
        nextArrow: $('.next-btn'),
        dots: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.crew-slider_row').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var allSlides = $('.crew-slider_row .slick-slide');
        var allActiveSlides = allSlides.filter('.slick-active');
        var firstActiveSlide = allActiveSlides.first();
        var lastActiveSlide = allActiveSlides.last();

        if (nextSlide > currentSlide) {
            var nextSlideElement = lastActiveSlide.next();
            if (nextSlideElement.length > 0) {
                nextSlideElement.css('opacity', '1');
            }
        } else {
            var prevSlideElement = firstActiveSlide.prev();
            if (prevSlideElement.length > 0) {
                prevSlideElement.css('opacity', '1');
            }
        }
    });

    $('.crew-slider_row').on('afterChange', function(event, slick, currentSlide){
        var allSlides = $('.crew-slider_row .slick-slide');
        var allActiveSlides = allSlides.filter('.slick-active');
        allSlides.css('opacity', '0');
        allActiveSlides.css('opacity', '1');
        allSlides.css('pointer-events', 'none');
        allActiveSlides.css('pointer-events', 'inherit');        
    });
  }

  crewSliderSetup();
  $(window).resize(debounce(crewSliderSetup, 250));


  $('.recover_like_row').slick({
    infinite:true,
    slidesToShow: 3,
    arrows: true,
    prevArrow: $('.prev-btn'),
    nextArrow: $('.next-btn'),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.slick-wrap').slick({
    infinite:true,
    slidesToShow: 1,
    arrows: true,
    prevArrow: $('.slick-prev-wrap'),
    nextArrow: $('.slick-next-wrap')
  });


  function slickSocialSliderSetup(){
    var slickSocialSlideCount = $('.slick-social-wrap .swiper-slide').length;
    
    if($('.slick-social-wrap').hasClass('slick-initialized') ){
      $('.slick-social-wrap').off();
      $('.slick-social-wrap').slick('unslick');
    }
    if(slickSocialSlideCount > 4){
      $('.slick-social-wrap').on('init', function(event, slick){
        var allSlides = $('.slick-social-wrap .slick-slide');
        var allActiveSlides = allSlides.filter('.slick-active');
        allSlides.css('opacity', '0.2' );

        if( $(window).width() > 767 ){
            allActiveSlides = allActiveSlides.slice(0, -1);
        }
        
        allActiveSlides.css('opacity', '1');
      });
    }

    $('.slick-social-wrap').slick({
      // infinite:true,
      slidesToShow: 4,
      arrows: true,
      dots: true,
      prevArrow: `<button class="prev owl-prev" aria-label="owl slide next" role="button" style="display: flex;"><span class="visually-hidden">Previous</span></button>`,
      nextArrow: `<button class="next owl-next" aria-label="owl slide next" role="button" style="display: flex;"><span class="visually-hidden">Next</span></button>`,
      appendArrows: ".social-slick-arrows",
      centerMode: slickSocialSlideCount > 4 ? true : false,
      centerPadding: '130px',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: true,
          }
        }
      ],
    });

    $('.social-slide').each(function() {
      $(this).height($(this).width());
    });

    if(slickSocialSlideCount > 4){
      $('.slick-social-wrap').on('afterChange', function(event, slick, currentSlide){
        var allSlides = $('.slick-social-wrap .slick-slide');
        var allActiveSlides = allSlides.filter('.slick-active');
        allSlides.css('opacity', '0.2' );

        if( $(window).width() > 767 ){
            allActiveSlides = allActiveSlides.slice(0, -1);
        }
        
        allActiveSlides.css('opacity', '1');
      });
    }
  }

  slickSocialSliderSetup();
  $(window).resize(debounce(slickSocialSliderSetup, 250));


  $('.slick-recover-wrap').slick({
    infinite:false,
    slidesToShow: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite:false,
          slidesToShow: 1,
          arrows: true,
          prevArrow: '<button class="owl-prev" aria-label="owl slide prev" role="button" style="display: flex;"><span class="visually-hidden">Previous</span></button>',
          nextArrow: '<button class="owl-next" aria-label="owl slide next" role="button" style="display: flex;"><span class="visually-hidden">Next</span></button>',
          appendArrows: ".slick-pit-recover-arrows .owl-nav",
        }
      }
    ]
  });
    

  var originalCollectionHTML = $('.collection_slide_wrap').html();

  function collectionSliderSetup(){
    if( $('.collection_slide_wrap').hasClass('slick-initialized') ){
      $('.collection_slide_wrap').off();
      $('.collection_slide_wrap').slick('unslick');
      $($('.collection_slide_wrap')[0]).html(originalCollectionHTML);
    }

    $('.collection_slide_wrap').on('init', function(event, slick, currentSlide){
      var allSlides = $('.collection_slide_wrap .slick-slide');
      var allActiveSlides = allSlides.filter('.slick-active');
      allSlides.css('opacity', '0' );
      // allSlides.css('pointer-events', 'none');
      allActiveSlides.css('opacity', '1');
      // allActiveSlides.css('pointer-events', 'auto');
    });

    $('.collection_slide_wrap').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 640,
          settings: {
            arrows: true,
            slidesToScroll: 1,
            slidesToShow: 1
          }
        }
      ]
    });

    $('.collection_slide_wrap').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var allSlides = $('.collection_slide_wrap .slick-slide');
      var allActiveSlides = allSlides.filter('.slick-active');
      var firstActiveSlide = allActiveSlides.first();
      var lastActiveSlide = allActiveSlides.last();
      
      if (nextSlide > currentSlide) {
        var nextSlideElement = lastActiveSlide.next();
        if (nextSlideElement.length > 0) {
            nextSlideElement.css('opacity', '1');
        }
      } else {
          var prevSlideElement = firstActiveSlide.prev();
          if (prevSlideElement.length > 0) {
              prevSlideElement.css('opacity', '1');
          }
      }  
    });

    $('.collection_slide_wrap').on('afterChange', function(event, slick, currentSlide){
      var allSlides = $('.collection_slide_wrap .slick-slide');
      var allActiveSlides = allSlides.filter('.slick-active');
      allSlides.css('opacity', '0' );    
      allActiveSlides.css('opacity', '1');
    });
  }

  collectionSliderSetup();

  $('.collection_slide_wraps').owlCarousel({
    stagePadding: 75,
    loop:false,
    rewind:true,
    margin:0,
    nav:true,
    responsive:{ 
      0:{
        items:1,
        stagePadding: 20,
        margin:0
      },
      640:{
        items:1,
        stagePadding: 150,
        margin:0
      },
      992:{
        items:2
      },
      1200:{
        items:3
      }
    }
  })
    
  $(window).load(function(){
    $('.collection_slide_wraps').find('.owl-next').trigger('click');
  });

  $('.review_slide').slick({
    infinite: true,
    slidesToShow: 1,
    // prevArrow: $('.prev-btn'),
    // nextArrow: $('.next-btn'),
    dots: true,
    customPaging: function(slick,index) {
      return '<a>' + (index + 1) + '</a>';
    },
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.marquee__item_slide').slick({
    slidesToShow: 1,
    infinite:true,
    slidesToScroll: 1,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 70000,
    arrows:false,
    cssEase: 'linear'
  });
    
  $(function () {
    $('.triggerita').magnificPopup({
      type: 'inline'
    });
  });

  function containerWidth() {
    var Width = $(".footer_wrap .container").outerWidth();
    var winwidth = $(window).width();
    var Diff = (winwidth-Width)/2;

    $('.featured_text').css('padding-left', Diff +'px');
    $('.member-banner-text').css('padding-left', Diff +'px');
  }

  $(document).on('ready', function(){
    setTimeout(function(){ 
      $('.join_wrap').addClass('active'); 
  }, 3000);
    containerWidth();
  }); 

  $('.slick-logo-wrapper').each(function(){
    $(this).slick({
      infinite:true,
      slidesToShow: 5,
      arrows: false,
      autoplay: true,
      speed: 300,
      responsive: [
        {
          breakpoint: 930,
          settings: {
            infinite:false,
            slidesToShow: 4,
            arrows: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            infinite:false,
            slidesToShow: 3,
            arrows: false,
          }
        }
      ]
    });
  });

  // homepage logo slider set id with aria-desribeby value for Audio Eye fix
  $('.logo-slide').each(function () {
    var $slide = $(this);    
    if ($slide.attr('aria-describedby') != undefined) { // ignore extra/cloned slides
        $(this).attr('id', $slide.attr('aria-describedby'));
    }
  });


  // Script for hoverable section autoplay & control
  $(document).ready(function() {
    var $tabs = $('.hoverable-tabs__item');
    var currentIndex = 0;
    var intervalTime = 8000;
    var interval;
    var isPaused = false;
    var $playButton = $('.hover-tabs-play');
  
    function activateTab(index) {
      $tabs.each(function(i) {
        if (i === index) {
          $(this).addClass('active');
          $(this).attr('aria-selected', 'true');
        } else {
          $(this).removeClass('active');
          $(this).attr('aria-selected', 'false');
        }
      });
      currentIndex = index;
    }
  
    function nextTab() {
      var nextIndex = (currentIndex + 1) % $tabs.length;
      activateTab(nextIndex);
    }
  
    function startInterval() {
      interval = setInterval(nextTab, intervalTime);
    }
  
    function stopInterval() {
      clearInterval(interval);
    }
  
    activateTab(0);
    startInterval();
  
    $tabs.each(function(index) {
      $(this).on('mouseenter focus', function() {
        activateTab(index);
        if (!isPaused) {
          stopInterval();
          startInterval();
        }
      });
  
      $(this).on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          activateTab(index);
          e.preventDefault();
        }
      });

      $(this).on('touchstart', function() {
        activateTab(index);
        if (!isPaused) {
          stopInterval();
          startInterval();
        }
      });
    });
  
    // Play/Pause button functionality
    $playButton.on('click', function() {
      if (isPaused) {
        startInterval();
        $(this).attr({ 'aria-pressed': 'false', 'aria-label': 'Pause' });
        // Change icon to pause icon
        $(this).html('<svg aria-label="pause" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="#fff" d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h2v6h-2zM9 5h2v6h-2z"></path></svg>');
        isPaused = false;
      } else {
        stopInterval();
        $(this).attr({ 'aria-pressed': 'true', 'aria-label': 'Play' });
        // Change icon to play icon
        $(this).html('<svg aria-label="play" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="#fff" d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM6 4.5l6 3.5-6 3.5z"></path></svg>');
        isPaused = true;
      }
    });
  });


  // script for full section slider
  $(document).ready(function() {
    var $section = $('.full-section-slider');
    var $slides = $('.slide');
    var $slideTitles = $('.slide-title');
    var currentIndex = 0;
    var intervalTime = 12000;
    var interval;
    var isPaused = false;
    var $playButton = $('.slider-play-pause');
    var progressInterval;
    var progressTime = 100;
  
    function activateSlide(index) {
      // Update the background image of the section
      var imageUrl = $slides.eq(index).data('image-url');
      $section.css('background-image', 'url(' + imageUrl + ')');
  
      
      $slides.hide();
      $slides.eq(index).show();
  
      
      $slideTitles.each(function(i) {
        if (i === index) {
          $(this).css('opacity', '1');
          $(this).attr('aria-selected', 'true');
        } else {
          $(this).css('opacity', '0.5');
          $(this).attr('aria-selected', 'false');
        }
      });
  
      currentIndex = index;

      stopProgressBar(); 
      $('.progress-bar').css('width', '0%');
      if (!isPaused) {
        startProgressBar();
      }      
    }
  
    function nextSlide() {
      var nextIndex = (currentIndex + 1) % $slides.length;
      activateSlide(nextIndex);
    }
  
    function startInterval() {
      clearInterval(interval);
      interval = setInterval(nextSlide, intervalTime);
      startProgressBar();
    }
  
    function stopInterval() {
      clearInterval(interval);
      stopProgressBar();
    }
  
    function startProgressBar() {
      clearInterval(progressInterval);
      var progressBar = $slideTitles.eq(currentIndex).find('.progress-bar');
      var width = 0;
      progressInterval = setInterval(function() {
        width += (progressTime / intervalTime) * 100;
        if (width >= 100) {
          width = 100;
          clearInterval(progressInterval);
        }
        progressBar.css('width', width + '%');
      }, progressTime);
    }
  
    function stopProgressBar() {  
      clearInterval(progressInterval);
      $('.progress-bar').css('width', '0%');
    }
  
    activateSlide(0);
    startInterval();
  
    $slideTitles.each(function(index) {
      $(this).on('click', function() {
        activateSlide(index);
        if (!isPaused) {
          stopInterval();
          startInterval();
        }
      });
  
      $(this).on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          activateSlide(index);
          e.preventDefault();
        }
      });
    });
  
    // Play/Pause button functionality
    $playButton.on('click', function() {
      if (isPaused) {
        startInterval();
        $(this).attr({ 'aria-pressed': 'false', 'aria-label': 'Pause' });
        // Change icon to pause icon
        $(this).html('<svg aria-label="pause" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="#fff" d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h2v6h-2zM9 5h2v6h-2z"></path></svg>');
        isPaused = false;
      } else {
        stopInterval();
        $(this).attr({ 'aria-pressed': 'true', 'aria-label': 'Play' });
        // Change icon to play icon
        $(this).html('<svg aria-label="play" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="#fff" d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM6 4.5l6 3.5-6 3.5z"></path></svg>');
        isPaused = true;
      }
    });
  });
  
  
  function adjustSlideHeights(selector){
    selector = selector + ' .slick-slide';
    var maxHeight = 0;
    $(selector).each(function(){
        let isDesktop = window.innerWidth > 1320 ? true : false;
        // Reset height to auto to get natural height
        $(this).css('height', 'auto');
        
        var slideHeight = $(this).outerHeight(!isDesktop);
        if(slideHeight > maxHeight){
            maxHeight = slideHeight;
        }
    });
    // Set all slides to the max height
    $(selector).css('height', maxHeight + 'px');
  }
  
})(jQuery);

function alignMegaMenus() {
  document.querySelectorAll(".nav-element.has-mega").forEach((item) => {
    const inner = item.querySelector(".MegaMenu__Inner");
    if (!inner) return;

    const { left } = item.getBoundingClientRect();
    inner.style.setProperty("--menu-offset", `${Math.round(left - 320)}px`);
  });
}

alignMegaMenus();

window.addEventListener("resize", alignMegaMenus);
window.addEventListener("scroll", alignMegaMenus, { passive: true });